export const MAX_IMAGE_SIZE_IN_BYTES = 1024 * 1024;
export const WARNING_IMAGE_SIZE_IN_BYTES = 1024 * 512;

// The backend stores a creative without a tag as this placeholder div and skips the macro check for it,
// while the form shows an empty field instead.
export const PLACEHOLDER_TAG_CONTENT = '<div></div>';
